export default __webpack_public_path__ + "static/media/img-01-divyae.5f0ed44f.jpg";